import { React, useState, useEffect } from "react";
import {
	List,
	ListItemText,
	ListItem,
	ListItemIcon,
	Collapse,
	useMediaQuery,
} from "@mui/material";
import {
	ExpandLess,
	ExpandMore,
	DeleteOutlineOutlined,
	EditOutlined,
} from "@mui/icons-material";
import "./CategoryList.scss";
import SubcategoryList from "./SubcategoryList";
import { useEditCategoryGroupMutation } from "../../services/queryHooks";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import AddCategoryModal from "./modals/AddCategoryModal";
import EditCategoryGroupModal from "./modals/EditCategoryGroupModal";
import ColorDisplayAndPicker from "../../components/common/ColorDisplayAndPicker";

export default function CategoryList({ categoryGroup, openDeleteModal }) {
	const [isExpanded, setIsExpanded] = useState(true);
	const [isCategoryEditOn, setIsCategoryEditOn] = useState(false);
	const [isAddSubcategoryOn, setIsAddSubcategoryOn] = useState(false);

	const isMobile = useMediaQuery("(max-width: 600px)");

	const editCategoryGroupMutation = useEditCategoryGroupMutation();

	const theme = useTheme();
	const { t } = useTranslation();

	useEffect(() => {
		if (isMobile) {
			setIsExpanded(false);
		} else {
			setIsExpanded(true);
		}
	}, [isMobile]);

	const handleColorChange = (color) => {
		editCategoryGroupMutation.mutate({
			categoryGroupId: categoryGroup._id,
			color: color,
		});
	};

	const listStyles = {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
		m: 1,
		py: 1,
		px: 2,
		borderRadius: "10px",
	};

	return (
		<>
			<List sx={listStyles}>
				<ListItem sx={{ p: 0 }} key={categoryGroup._id}>
					<ColorDisplayAndPicker
						color={categoryGroup.color}
						onColorChange={handleColorChange}
						isEditable={true}
					/>

					<ListItemText
						primary={
							categoryGroup.groupName
								? categoryGroup.groupName
								: t(categoryGroup.groupTranslationKey)
						}
						primaryTypographyProps={{
							sx: { fontWeight: "bold" },
						}}
					/>
					<ListItemIcon
						sx={{ minWidth: "auto", ml: 1 }}
						onClick={() => setIsCategoryEditOn(true)}
					>
						<EditOutlined className="hover" />
					</ListItemIcon>
					<ListItemIcon
						sx={{ minWidth: "auto", ml: 1 }}
						onClick={() => openDeleteModal(categoryGroup)}
					>
						<DeleteOutlineOutlined className="hover" />
					</ListItemIcon>
					<ListItemIcon sx={{ minWidth: "auto", ml: 1 }}>
						{isExpanded ? (
							<ExpandLess
								sx={{ cursor: "pointer" }}
								onClick={() => setIsExpanded(!isExpanded)}
							/>
						) : (
							<ExpandMore
								sx={{ cursor: "pointer" }}
								onClick={() => setIsExpanded(!isExpanded)}
							/>
						)}
					</ListItemIcon>
				</ListItem>
				<Collapse in={isExpanded}>
					<List>
						{categoryGroup.subcategories.map((subcategory) => (
							<SubcategoryList
								key={subcategory._id}
								categoryGroupId={categoryGroup._id}
								subcategory={subcategory}
								type={categoryGroup.type}
							/>
						))}
						<ListItem
							sx={{ pl: 1, py: 0 }}
							key={`add ${categoryGroup._id}`}
						>
							<ListItemText
								secondary={"+ " + t("addNewCategory")}
								sx={{ cursor: "pointer" }}
								onClick={() => setIsAddSubcategoryOn(true)}
							/>
						</ListItem>
					</List>
				</Collapse>
			</List>

			<EditCategoryGroupModal
				isOpen={isCategoryEditOn}
				onClose={() => setIsCategoryEditOn(false)}
				categoryGroup={categoryGroup}
			/>
			<AddCategoryModal
				isOpen={isAddSubcategoryOn}
				onClose={() => setIsAddSubcategoryOn(false)}
				categoryGroup={categoryGroup}
			/>
		</>
	);
}
